<nb-card>
  <nb-card-header>
    <h6>Đăng ký tài khoản</h6>

    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="cancel()"
      [disabled]="submitted"
      [class.btn-pulse]="submitted"
    >
      <nb-icon icon="close-outline"></nb-icon></button
  ></nb-card-header>
  <nb-card-body>
    <form [formGroup]="diaForm">
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="inputFullname" class="label text-primary">
              Tên cửa hàng
              <strong class="text-danger">*</strong>
            </label>
            <input
              type="text"
              nbInput
              fullWidth
              id="inputFullname"
              class="form-control"
              formControlName="title"
              [(ngModel)]="shop.title"
            />
          </div>
          <div class="form-group">
            <label for="inputAddress" class="label text-primary">
              Địa chỉ
              <strong class="text-danger">*</strong>
            </label>
            <input
              type="text"
              nbInput
              fullWidth
              id="inputAddress"
              class="form-control"
              formControlName="address"
              [(ngModel)]="shop.address"
            />
          </div>
          <div class="form-group">
            <label class="label text-primary">
              Điện thoại <strong class="text-danger">*</strong>
            </label>
            <input
              type="tel"
              nbInput
              fullWidth
              id="inputMobile"
              class="form-control"
              formControlName="mobile"
              [(ngModel)]="shop.mobile"
            />
          </div>
          <div class="form-group">
            <label class="label"> Mô tả</label>
            <textarea
              nbInput
              fullWidth
              rows="5"
              id="inputDescription"
              placeholder="{{ 'common.note' | translate }}"
              class="form-control"
              formControlName="description"
              [(ngModel)]="shop.description"
            ></textarea>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="form-group">
            <label class="label text-primary">
              Họ và tên
              <strong class="text-danger">*</strong>
            </label>
            <input
              type="text"
              nbInput
              fullWidth
              class="form-control"
              formControlName="displayName"
              [(ngModel)]="user.displayName"
            />
          </div>
          <div class="form-group">
            <label class="label text-primary">
              Email
              <strong class="text-danger">*</strong>
            </label>
            <input
              type="email"
              nbInput
              fullWidth
              id="inputEmail"
              class="form-control"
              formControlName="email"
              [(ngModel)]="user.email"
            />
          </div>

          <div class="form-group">
            <label class="label text-primary">
              Mật khẩu
              <strong class="text-danger">*</strong>
            </label>
            <input
              type="text"
              nbInput
              fullWidth
              id="inputPassword"
              class="form-control"
              formControlName="password"
              [(ngModel)]="user.password"
            />
          </div>

          <div class="form-group">
            <label for="inputPolicy" class="label"> Phân hệ </label>
            <div class="col-sm-9">
              <div class="form-group">
                <nb-checkbox
                  formControlName="purchase"
                  [(ngModel)]="shop.purchase"
                  status="warning"
                >
                  Mua hàng
                </nb-checkbox>

                <nb-checkbox
                  formControlName="finance"
                  [(ngModel)]="shop.finance"
                  status="warning"
                >
                  Thu/Chi
                </nb-checkbox>
              </div>

              <div class="form-group">
                <nb-checkbox
                  formControlName="receipt"
                  [(ngModel)]="shop.receipt"
                  status="success"
                >
                  Bán lẻ
                </nb-checkbox>

                <nb-checkbox
                  formControlName="trade"
                  [(ngModel)]="shop.trade"
                  status="success"
                >
                  Bán sỉ
                </nb-checkbox>
              </div>

              <div class="form-group">
                <nb-checkbox
                  formControlName="warehouse"
                  [(ngModel)]="shop.warehouse"
                  status="info"
                >
                  Kho
                </nb-checkbox>

                <nb-checkbox
                  formControlName="working"
                  [(ngModel)]="shop.working"
                  status="info"
                >
                  Làm việc
                </nb-checkbox>
              </div>

              <div class="form-group"></div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </nb-card-body>
  <nb-card-footer>
    <button
      type="submit"
      nbButton
      status="primary"
      size="small"
      [disabled]="submitted || !diaForm.valid"
      [class.btn-pulse]="submitted"
      (click)="submit()"
    >
      <nb-icon icon="save-outline"></nb-icon>
      Đăng ký
    </button>
  </nb-card-footer>
</nb-card>
